export default __webpack_public_path__ + "static/media/alamo-arte-4.1c53e56d.webp";